"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _CalendarContext = _interopRequireDefault(require("../CalendarContext"));

var _classnames = _interopRequireDefault(require("../util/classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CellWithoutMemo = function CellWithoutMemo(_ref) {
  var _context$components;

  var index = _ref.index,
      onClick = _ref.onClick,
      mode = _ref.mode,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["index", "onClick", "mode"]);
  var handleCellClick = (0, _react.useCallback)(function () {
    return onClick(index);
  }, [onClick, index]);
  var context = (0, _react.useContext)(_CalendarContext.default);

  var props = _objectSpread({
    onClick: handleCellClick
  }, rest);

  return (_context$components = context.components) !== null && _context$components !== void 0 && _context$components.Cell ? /*#__PURE__*/_react.default.createElement(context.components.Cell, (0, _extends2.default)({
    mode: mode
  }, props)) : /*#__PURE__*/_react.default.createElement("div", props);
};

var Cell = /*#__PURE__*/(0, _react.memo)(CellWithoutMemo);

var TBody = function TBody(_ref2) {
  var cells = _ref2.cells,
      onCellClick = _ref2.onCellClick,
      col = _ref2.col,
      row = _ref2.row,
      mode = _ref2.mode;

  var _useContext = (0, _react.useContext)(_CalendarContext.default),
      prefixCls = _useContext.prefixCls;

  var cls = (0, _react.useMemo)(function () {
    return {
      body: prefixCls + '-tbody',
      row: prefixCls + '-row',
      cell: prefixCls + '-cell',
      emptyCell: prefixCls + '-cell-empty',
      firstDisabledCell: prefixCls + '-cell-disabled-first',
      lastDisabledCell: prefixCls + '-cell-disabled-last'
    };
  }, [prefixCls]);
  var handleClick = (0, _react.useCallback)(function (index) {
    var cellInfo = cells[index];
    if (!cellInfo) return;
    onCellClick(index);
  }, [cells, onCellClick]);

  var renderBody = function renderBody() {
    var info = [];

    for (var i = 0; i < row; i++) {
      var group = [];
      var first = true;

      for (var j = 0; j < col; j++) {
        var index = i * col + j;
        var cellInfo = cells[index];
        var isFirstDisabled = false;
        var isLastDisabled = false;

        if (cellInfo !== null && cellInfo !== void 0 && cellInfo.disabled) {
          if (first) {
            isFirstDisabled = true;
            first = false;
          }

          var nextCellInfo = cells[index + 1];

          if (j >= col - 1 || !(nextCellInfo !== null && nextCellInfo !== void 0 && nextCellInfo.disabled)) {
            isLastDisabled = true;
          }
        } else {
          first = true;
        }

        group.push( /*#__PURE__*/_react.default.createElement(Cell, {
          key: index,
          className: (0, _classnames.default)(cls.cell, !cellInfo && cls.emptyCell, cellInfo === null || cellInfo === void 0 ? void 0 : cellInfo.className, isFirstDisabled && cls.firstDisabledCell, isLastDisabled && cls.lastDisabledCell),
          index: index,
          onClick: handleClick,
          mode: mode
        }, cellInfo === null || cellInfo === void 0 ? void 0 : cellInfo.children));
      }

      info.push( /*#__PURE__*/_react.default.createElement("div", {
        key: i,
        className: cls.row
      }, group));
    }

    return info;
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: cls.body
  }, renderBody());
};

var _default = /*#__PURE__*/(0, _react.memo)(TBody);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@z-r/calendar/lib/view/TBody.js
// module id = 1337
// module chunks = 6 7 17 18